import styled, { css } from 'styled-components'

import { fontType, mediaQuery, toRem } from '../../styles/functions'
import { IBadgeWrapper } from './types'

export const BadgeWrapper = styled.div<IBadgeWrapper>`
	/* inline-flex para a pill não esticar quando o pai for um bloco */
	display: inline-flex;
	align-items: center;
	gap: 8px;
	height: 30px;
	padding: 0 14px;
	border-radius: 15px;
	user-select: none;
	white-space: nowrap;
	font-size: ${toRem(13)};
	letter-spacing: 0.2px;
	text-transform: capitalize;
	background: ${({ theme, $color }) => theme.colors[$color]};
	color: ${({ theme }) => theme.colors.white};
	${fontType(1)}

	.dot {
		display: block;
		width: 9px;
		height: 9px;
		border-radius: 100%;
		background: ${({ theme }) => theme.colors.white};
		box-shadow: 0 0 0 3px ${({ theme }) => `${theme.colors.white}3D`};
	}

	${({ $fixed }) =>
		$fixed &&
		css`
			position: fixed;
			left: 16px;
			bottom: 16px;
			/* abaixo do SideNav (z-index 10) e do Header (20) */
			z-index: 5;
			pointer-events: none;

			${mediaQuery('sm')(`
				left: 12px;
				bottom: 12px;
			`)}
		`}
`

export const InlineBadge = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	flex-wrap: wrap;

	.prefix {
		color: ${({ theme }) => theme.colors.darkGrey};
		font-size: ${toRem(14)};
		${fontType(0)}
	}
`
